import {
    ENTRY_CHILDREN_REQUESTED,
    ENTRY_CHILDREN_UPDATE_REQUESTED,
    ENTRY_CHILDREN_RECEIVED,
    ENTRY_CHILDREN_ERROR
} from '../actions/entryDetailChildren';
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";
import {ENTRY_DETAIL_UNMOUNT} from "../actions/entryDetail";

/**
 *
 * @param {RequestResult} state
 * @param {BaseAction|EntryIdAction|ReceiveRelatedEntriesAction|ReceiveEntryErrorAction} action
 * @return {RequestResult}
 */
export const entryDetailChildren = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

    switch (action.type) {
        case ENTRY_CHILDREN_REQUESTED:
            return new RequestResult(RequestState.getInstanceLoading(), null);
        case ENTRY_DETAIL_UNMOUNT:
            return new RequestResult(RequestState.getInstanceInit(), null);
        case ENTRY_CHILDREN_UPDATE_REQUESTED:
            return new RequestResult(RequestState.getInstanceUpdating(), state.data);
        case ENTRY_CHILDREN_RECEIVED:
            return new RequestResult(RequestState.getInstanceDone(), action.entries, action.receivedAt);
        case ENTRY_CHILDREN_ERROR:
            return new RequestResult(
                RequestState.getInstanceError(
                    action.errorResponseStatusCode,
                    action.errorResponseMessage ? action.errorResponseMessage : null
                ),
                state.getData()
            );
        default:
            return state
    }
};
